module.exports = __webpack_public_path__ + "static/media/flag-uk.2654334e.png";